// extracted by mini-css-extract-plugin
export default {"price":"g8-z","onSale":"h8-z","msrpLabelPrice":"i8-z","msrpLabel":"j8-z","originalPrice":"k8-z","percentOff":"l8-z"};